
import React, {Component} from 'react'
import { Xhr } from 'hlp'



export default class DomainInp extends Component {

  constructor(props) {
    super()
    this.state = {
      inFocus: false,
      descVisible: false,
      val: '',
      baseDomain: ''
    }

  }





  componentWillMount() {
    Xhr.loadJSON( '/constants.json' )
      .then( resp => {
        if ( resp.hasErr ) {
          console.log('resp: ', resp);
          return
        }
        this.setState( {
          baseDomain: resp.value.BASE_DOMAIN
        } )
      } )
  }



  handleFocus() {
    this.setState({inFocus: true})
  }

  handleBlur() {
    this.setState({inFocus: false})
  }

  rememberVal(ev) {
    let val = ev.target.value

    this.setState({val})

    this.props.oninput()
  }

  hangleClickQuestion(ev) {
    ev.preventDefault()
    this.setState({descVisible: true})

    this.handleDocClickTmp = this.handleDocClick.bind(this)
    setTimeout(() => {
      document.addEventListener('click', this.handleDocClickTmp)
    }, 10)

  }

  handleDocClick(ev) {
    this.setState({descVisible: false})

    document.removeEventListener('click', this.handleDocClickTmp)
    this.handleDocClickTmp = null
  }

  render() {
    let txt = this.props.txt || ''
    let txtDesc = this.props.txtDesc || ''
    let wrpClass = 'platformNameWrp '

    wrpClass += this.props.errClass
    wrpClass += (this.state.inFocus || this.state.val !== '') ? 'inFocus ' : ''
    wrpClass += this.state.descVisible ? 'descVis ' : ''

    return (
      <label className={wrpClass}>
        <span>{txt}</span>
        <span className="error">{this.props.textErr}</span>
        <input
          minLength={2}
          maxLength={30}
          name="platformName"
          type="text"
          value={this.state.val}
          data-type="domain"
          onFocus={() => this.handleFocus() }
          onBlur={() => this.handleBlur() }
          onInput={ev => this.rememberVal(ev)}
					className={ this.props.className }
        />
        <span className="plholder"><i>domain</i>.{ this.state.baseDomain }</span>

        <div className="question">
          <b onClick={ev => this.hangleClickQuestion(ev)}>?</b>

          <div className="domainDesc" ref="desc" dangerouslySetInnerHTML={{ __html: txtDesc }} />
        </div>

      </label>
    )
  }

}



// WEBPACK FOOTER //
// ./src/form/domain.jsx